module.exports = __webpack_public_path__ + "static/img/areaA-18.1d1e0a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-18.png
// module id = 929
// module chunks = 1